var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListvehiclestep1Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b,.c{fill:none;}.b{stroke:#8ac43d;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.c{opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-609 -1419)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(609 1419)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(449 1243)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(172 188)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15,7.5A7.5,7.5,0,1,1,7.5,0,7.5,7.5,0,0,1,15,7.5Z",
    transform: "translate(10.5 3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,10.5C0,4.7,5.775,0,12.885,0a15.586,15.586,0,0,1,4.14.555",
    transform: "translate(5.115 22.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12,6a5.391,5.391,0,0,1-.18,1.395,5.6,5.6,0,0,1-.69,1.7A5.955,5.955,0,0,1,6,12a5.881,5.881,0,0,1-3.99-1.545A5.525,5.525,0,0,1,.87,9.09,5.881,5.881,0,0,1,0,6,5.991,5.991,0,0,1,6,0a5.916,5.916,0,0,1,4.455,2A5.976,5.976,0,0,1,12,6Z",
    transform: "translate(21 21)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.765 24.78)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.47,0H0",
    transform: "translate(0 2.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0V4.485",
    transform: "translate(2.235)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0H36V36H0Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListvehiclestep1Icon);
export default __webpack_public_path__ + "static/media/listvehiclestep1icon.389dc35db579359122ac645750dc14d8.svg";
export { ForwardRef as ReactComponent };